module.exports = __webpack_public_path__ + "img/stvrt-promenada.f718dab1.jpg";